import React, { Component } from 'react';
import styles from './FollowList.module.css';
import axios from 'axios';
import {connect} from 'react-redux';
import checkedUserIcon from '../../../assets/checked_user.png';
import {Link} from 'react-router-dom';
import loader from '../../../assets/loader2.svg';

class FollowList extends Component {
  
    state = {
        users: [],
        modal: {
            isModalOpen: false,
            userId: '',
            name: '',
            profilePic: '',
            clicked: false
        },
        isLoading: true
    }

    componentDidMount() {
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';

        axios.get('/users.json?auth='+ this.props.loginStatus.authToken)
        .then(response=>{
            let users = [];
            Object.keys(response.data)
            .filter(userId => this.props.data.followList.indexOf(userId) !== -1)
            .map(userId => {
                users.push({[userId]: response.data[userId]});
            });
           
           this.setState({
               users: users,
               isLoading: false
            });
           
        })
        .catch(error=>console.log(error))
    }
    
    componentWillUnmount() {
        document.getElementsByTagName('body')[0].style.overflow = '';
    }

    render() {
        return (
            <div className={styles.main}>
                <div className={styles.modal}>
                    <div className={styles.header}>
                            {this.props.data.name}
                            <button onClick={this.props.close}>
                            <svg fill="#262626" height="24" viewBox="0 0 48 48" width="24">
                            <path  d="M41.1 9.1l-15 15L41 39c.6.6.6 1.5 0 2.1s-1.5.6-2.1 
                            0L24 26.1l-14.9 15c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l14.9-15-15-15c-.6-.6-.6-1.5 
                            0-2.1s1.5-.6 2.1 0l15 15 15-15c.6-.6 1.5-.6 2.1 0 .6.6.6 1.6 0 2.2z">
                            </path></svg>
                            </button>
                    </div>
                    <div className={styles.body}>
                    {this.state.isLoading ?
                        <div style={{margin:'auto',marginTop:'35%'}}>
                             <img src={loader} alt="loading" width="30" height="30"/>
                        </div> : null
                    }
                    {!this.state.isLoading && this.state.users.length === 0 ?
                        <div className={styles.noUser}>No {this.props.data.name} Available</div>
                        :null
                    }
                    {this.state.users.map(userObject => {
                        let userId = Object.keys(userObject)[0];
                        let user = userObject[userId];
                    return (
                       <div className={styles.user} key={userId}>
                        <div className={styles.dp}>
                            <Link to={'/account/' + userId} >
                            <img src={user.profilePic} 
                            width="35" height="35" alt={user.name + '\'s profile pic'} /> 
                            </Link>
                        </div>
                        <div className={styles.details}>
                        <Link to={'/account/' + userId} >
                            <div className={styles.name}>
                            <h2>{user.name}</h2> 
                            {user.isVerified ?
                            <span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="16px" height="16px">
                            <polygon fill="#42a5f5" points="29.62,3 33.053,8.308 39.367,8.624 39.686,14.937 44.997,
                            18.367 42.116,23.995 45,29.62 39.692,33.053 39.376,39.367 33.063,39.686 29.633,44.997 24.005,
                            42.116 18.38,45 14.947,39.692 8.633,39.376 8.314,33.063 3.003,29.633 5.884,24.005 3,18.38 8.308,
                            14.947 8.624,8.633 14.937,8.314 18.367,3.003 23.995,5.884"/>
                            <polygon fill="#fff" points="21.396,31.255 14.899,24.76 17.021,22.639 21.428,27.046 30.996,
                            17.772 33.084,19.926"/>
                            </svg>
                            </span>
                            : null
                            }
                            
                        </div>
                        </Link>
                        
                        </div>
                        {userId !== this.props.loginStatus.userId && !this.props.data.isLike?
                        <div>
                            {this.props.data.following.indexOf(userId) === -1 ?
                            <button className={styles.follow} onClick={()=> this.props.follow(userId)}>
                                {this.props.data.followClicked.indexOf(userId) === -1 ?
                                'Follow' :
                                <img src={loader} alt="loader" width="18" height="18" style={{marginTop: '5px'}} />
                                } 
                            </button>
                            :
                            <button className={styles.following} 
                            onClick={()=>this.props.followingClickHandler(userId, user.name, user.profilePic)}>
                                <img src={checkedUserIcon} alt="following icon" width="20" height="20" />
                            </button> 
                            }
                            
                        </div>
                        :null}
                     </div>
                    )}) }
                    </div>
                </div>
            </div>
        )
     }
    }

const mapStateToProps = state => {
    return {
        loginStatus: state.loginStatus
    }
}
export default connect(mapStateToProps)(FollowList);